import YoutubeIcon from '../../../../assets/youtube.svg?react';
import InsIcon from '../../../../assets/instagram.svg?react';
import TikTokIcon from '../../../../assets/tiktok.svg?react';
import LinkedinIcon from '../../../../assets/linkedin.svg?react';
import ErrorIcon from '../../../../assets/error.svg?react';
import DefaultAvatarIcon from '../../../../assets/profile.svg?react';
import styles from './FJAccountItem.module.less';
import FJLocalStore from '@src/store/FJLocalStore';
import FJCheckBox from '@src/components/FJCheckBox/FJCheckBox.tsx';
import FJImage from '@src/common/components/FJImage/FJImage';
import FJDropdown from '@src/common/components/FJDropDown/FJDropDown.tsx';
import React, { type Ref } from 'react';

const platformIcons = {
    youtube: <YoutubeIcon />,
    instagram: <InsIcon />,
    tiktok: <TikTokIcon />,
    linkedin: <LinkedinIcon />,
};

interface Props {
    isPublished?: boolean;
    isSelected: boolean;
    isFailed: boolean;
    platform: string;
    avatarUrl: string;
    email: string;
    onClick?: (platform: string) => void;
    isShowErrorTips?: boolean;
}

const FJAccountItem = ({
    isSelected,
    isFailed,
    platform,
    avatarUrl,
    email,
    onClick,
    isShowErrorTips = false,
}: Props) => {
    const _onClick = () => {
        onClick?.(platform);
    };

    const _renderItem = (isDropdown: boolean, ref?: Ref<HTMLDivElement>, mouseMove?: React.MouseEventHandler) => {
        return (
            <div
                ref={ref}
                className={`${styles.accountItem} ${isSelected ? styles.selected : ''}`}
                onClick={!isDropdown ? _onClick : () => {}}
                onMouseMove={mouseMove}
            >
                <div className={styles.avatar_box}>
                    {avatarUrl ? (
                        <FJImage
                            imgSrc={avatarUrl}
                            imgClassName={styles.avatar}
                            boxClassName={styles.avatar_box}
                            disableDefaultImgClass
                            alt=''
                        />
                    ) : (
                        <DefaultAvatarIcon />
                    )}
                    <div className={styles.platformIcon}>{platformIcons[platform as keyof typeof platformIcons]}</div>
                </div>

                <div className={styles.userInfo}>
                    <div className={styles.platformTitle}>
                        {FJLocalStore._(platform)}
                        {isFailed && (
                            <div className={styles.error_box}>
                                <ErrorIcon />
                                <p className={styles.failed_text}>{FJLocalStore._('failed')}</p>
                            </div>
                        )}
                    </div>
                    <div className={styles.email}>{email}</div>
                </div>
                <div className={styles.checkbox}>
                    <FJCheckBox selected={isDropdown ? false : isSelected} disable={isDropdown} />
                </div>
            </div>
        );
    };

    if (isShowErrorTips) {
        return (
            <FJDropdown
                isTopLayer
                useAnchorBody
                trigger='hover'
                placement='rightTop'
                triggerDisplay='inline-flex'
                offsetLeft={5}
                overlayClassName={styles.help_popover_overlay}
                renderTrigger={({ ref, onMouseMove }) => _renderItem(true, ref, onMouseMove)}
                renderOverlay={({ ref }) => (
                    <div
                        ref={ref as Ref<HTMLDivElement>}
                        className={styles.error_dropdown}
                        onClick={e => e.stopPropagation()}
                    >
                        {FJLocalStore._('video-publish-requirements')}
                    </div>
                )}
                active
            />
        );
    } else {
        return _renderItem(false);
    }
};

export default FJAccountItem;
